import { Padrao } from '../generic/padrao';

export class AdendoPecasGrupo extends Padrao{

    override idTab = 144;

    nome: string;
    aviacao: string;
}
